<template>
    <div class="step-template">
        <div class="text-wrapper">
            <div class="left-wrapper">
                <h1>Lektionen</h1>
                <p class="h2">Vitadio hilft den Nutzenden, die Bedeutung von Verhaltensweisen und das Potenzial kleiner Änderungen der Gewohnheiten zu erkennen...</p>
            </div>
            <div class="right-wrapper">
                <h2>Informativ und praxisnah</h2>
                <p class="text">Die Lektionen sind vollgepackt mit evidenzbasierten Inhalten und umsetzbaren Tipps, die die Lücke zwischen Wissen und Handeln für die Nutzenden schließen.</p>
            </div>
        </div>

        <MobileTemplate @app-step-from-mobile-template="actualStep" :appStep="appStep" />
    </div>
</template>

<script>
export default {
    data(){
        return {
            appStep: 17
        }
    },

    methods: {
        actualStep() {
            this.$emit('app-step', ++this.appStep)
        }
    }
}
</script>

